import { MutableRefObject, useEffect, useRef, useState } from 'react';

function useElementHeight() {
  const ref = useRef<HTMLElement>(null);
  const [height, setHeight] = useState<number>(0);

  useEffect(() => {
    if (ref.current) {
      setHeight(ref.current.clientHeight);
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (ref.current) {
        setHeight(ref.current.clientHeight);
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return {
    ref: ref as MutableRefObject<HTMLElement>,
    height,
  };
}

export default useElementHeight;
